module.exports = __webpack_public_path__ + "img/listen.6bcceeb2.png";